module.exports = __webpack_public_path__ + "img/background4.d2e5ec48.png";